import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PPEData } from '../types/ppe';

interface HeaderProps {
  data?: PPEData | null;
}

const Header: React.FC<HeaderProps> = ({ data }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-white/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo and Brand */}
          <div className="flex items-center space-x-4">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="/ppecp-logo.png" 
                alt="Safety Workwear Shop" 
                className="h-12 w-auto rounded-lg"
              />
              <div className="hidden md:block">
                <div className="text-gray-900 title-font text-xl">PPE Certificate Portal</div>
                <div className="text-gray-500 text-sm">Powered by Safety Workwear Shop</div>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-gray-600 hover:text-gray-900 transition-colors duration-200 font-medium ${
                isActive('/') ? 'text-gray-900' : ''
              }`}
            >
              Home
            </Link>
            
            <Link
              to="/categories"
              className={`text-gray-600 hover:text-gray-900 transition-colors duration-200 font-medium ${
                isActive('/categories') ? 'text-gray-900' : ''
              }`}
            >
              Categories & Risk Levels
            </Link>
            
            <Link
              to="/search"
              className={`flex items-center space-x-2 px-4 py-2 rounded-full bg-yellow-500 text-gray-900 hover:bg-yellow-600 transition-all duration-200 font-medium ${
                isActive('/search') ? 'bg-yellow-600' : ''
              }`}
            >
              <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <span>Search</span>
            </Link>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-600 hover:text-gray-900 transition-colors duration-200"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <Link
                to="/"
                className="block px-3 py-2 text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded-md transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              
              <Link
                to="/categories"
                className="block px-3 py-2 text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded-md transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Categories
              </Link>
              
              <Link
                to="/search"
                className="block px-3 py-2 text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded-md transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Search
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
